import { useState, useEffect } from 'react';
import { ConsolePage } from './pages/ConsolePage';
import { LoginPage } from './pages/LoginPage';

function App() {
  const [backgroundImage, setBackgroundImage] = useState('/background-arcelor.png');
  const [authToken, setAuthToken] = useState<string | null>(() => {
    return typeof window !== 'undefined' ? localStorage.getItem('authToken') : null;
  });

  // Detecta Shift + L para alternar o background
  useEffect(() => {
    const handleKeyDown = (event: any) => {
      if (event.shiftKey && event.key.toLowerCase() === 'l') {
        setBackgroundImage(prev => {
          if (prev === '/background-arcelor.png') {
            return '/background-arcelor.png';
          } else {
            return '/background-arcelor.png';
          }
        });
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    setAuthToken(null);
  };

  if (!authToken) {
    return <LoginPage onLoginSuccess={(token) => setAuthToken(token)} />;
  }

  return (
    <>
      <div
        data-component="App"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: -1,
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: -1,
            backgroundImage: `url("${backgroundImage}")`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: '100% 100%',
            transition: 'background-image 2s ease-in-out',
          }}
        />
      </div>

      {/* Opcional: um botão de logout em algum lugar da sua UI */}
      <div style={{ position: 'fixed', top: 12, right: 12 }}>
        <button onClick={handleLogout}>Sair</button>
      </div>

      <ConsolePage authToken={authToken} />
    </>
  );
}

export default App;
